export default "/_next/static/images/error-500-e8580848b22150958dad39178433205b.svg";